export function init_lazyloading(){

  window.dzs_check_lazyloading_images_use_this_element_css_top_instead_of_window_scroll = null;


  window.dzs_check_lazyloading_images_toberesized_arr = [];
  window.dzs_check_lazyloading_inter = 0;
  window.dzs_check_lazyloading_images = function () {

    function check_scroll() {


      var st = jQuery(window).scrollTop();

      var wh = jQuery(window).height();

      if (window.dzs_check_lazyloading_images_use_this_element_css_top_instead_of_window_scroll) {

        st = -(parseInt(window.dzs_check_lazyloading_images_use_this_element_css_top_instead_of_window_scroll.css('top'), 10));
      }


      jQuery('img[data-src],.divimage[data-src],*[data-script-src], *[data-stylesheet-src]').each(function () {
        var _t = jQuery(this);


        if (_t.offset().top <= st + wh + 320) {


          if (_t.attr('data-src')) {
            var auximg = new Image();


            auximg.onload = function () {


              if (_t.attr('data-src')) {

                var aux34 = _t.attr('data-src');


                if (_t.hasClass('divimage')) {
                  _t.css('background-image', 'url(' + aux34 + ')');

                  window.dzs_check_lazyloading_images_toberesized_arr.push(_t);

                  _t.attr('data-responsive_ratio', this.naturalHeight / this.naturalWidth);

                  window.dzs_check_lazyloading_image_resize();
                } else {
                  _t.attr('src', aux34);
                }


                if (_t.attr('data-temp-rat')) {


                  _t.css({
                    'height': 'auto'
                  });

                }

                _t.attr('data-src', '');
                _t.addClass('loaded');
              }

              if (_t.hasClass('set-height-auto-after-load')) {

                _t.css('height', 'auto');
              }


              if (_t.parent().parent().parent().parent().parent().hasClass('mode-isotope')) {

                var _c = _t.parent().parent().parent().parent().parent();
                if (_c.get(0) && _c.get(0).api_relayout_isotope) {
                  _c.get(0).api_relayout_isotope();
                }
              }


            }

            auximg.src = _t.attr('data-src');
          }


          if (_t.attr('data-script-src')) {

            loadScript(_t.attr('data-script-src'), () => {


              _t.attr('data-script-src', '');

            })

            if (String(_t.attr('data-script-src')).indexOf('zfolio.js') > -1) {
              window.dzsap_loading_zfolio = true;
            }
            if (String(_t.attr('data-script-src')).indexOf('plugin.js') > -1) {
              window.dzsap_loading_as = true;
              window.dzs_loading_as = true;
            }

          }
          if (_t.attr('data-stylesheet-src')) {

            jQuery('<link/>', {
              rel: 'stylesheet',
              type: 'text/css',
              href: _t.attr('data-stylesheet-src')
            }).appendTo('head');


            _t.attr('data-stylesheet-src', '');

          }

        }
      })
    }

    if (window.dzs_check_lazyloading_inter) {
      clearTimeout(window.dzs_check_lazyloading_inter);
    }

    window.dzs_check_lazyloading_inter = setTimeout(function () {
      check_scroll()
    }, 30);

  }


  window.dzs_check_lazyloading_image_resize = function () {

    for (let i = 0; i < window.dzs_check_lazyloading_images_toberesized_arr.length; i++) {
      const $loadedImage = window.dzs_check_lazyloading_images_toberesized_arr[i];


      if (!$loadedImage.hasClass('do-not-set-js-height')) {

        $loadedImage.height(Number($loadedImage.attr('data-responsive_ratio')) * $loadedImage.width());
      }
    }
  }

  if (!(window.dzs_check_lazyloading_images_inited)) {

    window.dzs_check_lazyloading_images_inited = false;

    jQuery(window).on('resize', window.dzs_check_lazyloading_image_resize)
  }







  // -- loading


  if (!window.dzs_check_lazyloading_images_inited) {

    window.dzs_check_lazyloading_images_inited = true;


    jQuery('img[data-src],.divimage[data-src],*[data-script-src], *[data-stylesheet-src]').each(function () {

      var _t = jQuery(this);

      if (_t.attr('data-temp-rat')) {

        var temp_rat = Number(_t.attr('data-temp-rat'));


        _t.css({
          'height': (temp_rat * _t.outerWidth(false)) + 'px'
        });
      }
    });

    jQuery(window).bind('scroll.dzslazy', window.dzs_check_lazyloading_images);
    window.dzs_check_lazyloading_images();
    setTimeout(function () {
      window.dzs_check_lazyloading_images();
    }, 1500);
    setTimeout(function () {
      window.dzs_check_lazyloading_images();
    }, 2500);
  } else {
    if (window.dzs_check_lazyloading_images) {
      window.dzs_check_lazyloading_images();
      setTimeout(function () {
        if (window.dzs_check_lazyloading_images) {
          window.dzs_check_lazyloading_images();
        }
      }, 1000);
      setTimeout(function () {
        if (window.dzs_check_lazyloading_images) {
          window.dzs_check_lazyloading_images();
        }
      }, 2000);
      setTimeout(function () {
        if (window.dzs_check_lazyloading_images) {
          window.dzs_check_lazyloading_images();
        }
      }, 3000);
    }
  }

}